// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/index.css
// module id = u7k/
// module chunks = 0